import { API, Endpoints } from "@brg/api"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import urlApi from "shared/actions/urlApi"
import { SelectBoxOption } from "shared/components/inputs/SelectBox"

type PortfolioFolder = {
  id: string
  name: string
  description?: string
  entityIds?: string[]
  isAvailableAtLink?: boolean
  isDefault?: boolean
  isHidden?: boolean
  parentFolderIds?: string[]
  entityType?: string
}

type UseMagistracyPortfolioFoldersProps = {
  designerId?: string
}

export const useMagistracyPortfolioFolders = ({ designerId }: UseMagistracyPortfolioFoldersProps) => {
  const { t } = useTranslation()

  const fetchFolders = useCallback(async (): Promise<PortfolioFolder[]> => {
    if (!designerId) {
      return []
    }

    const data = await urlApi().fetchFolders(designerId)
    if (!Array.isArray(data)) {
      return []
    }

    return data
      .filter((folder) => folder?.id && folder?.name)
      .map((folder) => ({
        id: String(folder.id),
        name: String(folder.name),
        description: folder.description ?? "",
        entityIds: Array.isArray(folder.entityIds) ? folder.entityIds : [],
        isAvailableAtLink: folder.isAvailableAtLink,
        isDefault: folder.isDefault,
        isHidden: folder.isHidden,
        parentFolderIds: folder.parentFolderIds,
        entityType: folder.entityType,
      }))
  }, [designerId])

  const mapFoldersToOptions = useCallback((folders: PortfolioFolder[]): SelectBoxOption[] => {
    return folders.map((folder) => ({
      identifier: folder.id,
      name: folder.name,
    }))
  }, [])

  const generateFolderName = useCallback(async (): Promise<string> => {
    const localizedBaseName = t("magistracyPage.portfolio.default_folder_name")
    const folders = await fetchFolders()

    const existingNames = folders.map((folder) => folder.name)
    let folderName = localizedBaseName
    let counter = 2

    while (existingNames.includes(folderName)) {
      folderName = `${localizedBaseName} - ${counter}`
      counter++
    }

    return folderName
  }, [fetchFolders, t])

  const resolveCreatedFolderId = useCallback(
    (
      foldersBefore: PortfolioFolder[],
      foldersAfter: PortfolioFolder[],
      folderName: string,
      entityIds: string[]
    ): string | null => {
      const folderIdsBefore = new Set(foldersBefore.map((folder) => folder.id))

      const newFolder = foldersAfter.find((folder) => !folderIdsBefore.has(folder.id))
      if (newFolder?.id) {
        return newFolder.id
      }

      const folderByName = foldersAfter.find((folder) => folder.name === folderName)
      if (folderByName?.id) {
        return folderByName.id
      }

      if (entityIds.length === 0) {
        return null
      }

      const folderByProjects = foldersAfter.find((folder) => {
        const ids = folder.entityIds ?? []
        if (ids.length !== entityIds.length) {
          return false
        }
        return entityIds.every((id) => ids.includes(id))
      })

      return folderByProjects?.id ?? null
    },
    []
  )

  const createFolder = useCallback(
    async (entityIds: string[] = []): Promise<string | null> => {
      if (!designerId) {
        return null
      }

      const foldersBefore = await fetchFolders()
      const folderName = await generateFolderName()

      const response = await API.request()
        .endpoint(Endpoints.folders)
        .url("/api/Folder/CreateFolder")
        .body({
          name: folderName,
          description: "",
          isAvailableAtLink: true,
          entityIds,
          accountId: designerId,
        })
        .post()
        .send()

      const status = response?.status
      const isSuccess = status === 200 || status === 201 || status === 204

      if (!isSuccess) {
        return null
      }

      try {
        const data = await response.json()
        if (data?.message === "Too many folders") {
          return null
        }
        if (data?.id) {
          return String(data.id)
        }
      } catch {
        // 204 No Content — empty body
      }

      const foldersAfter = await fetchFolders()
      return resolveCreatedFolderId(foldersBefore, foldersAfter, folderName, entityIds)
    },
    [designerId, fetchFolders, generateFolderName, resolveCreatedFolderId]
  )

  const updateFolderProjects = useCallback(
    async (folderId: string, entityIds: string[]): Promise<boolean> => {
      if (!designerId || !folderId) {
        return false
      }

      const folders = await fetchFolders()
      const targetFolder = folders.find((folder) => folder.id === folderId)
      if (!targetFolder) {
        return false
      }

      const response = await API.fetch(`${Endpoints.folders}/api/Folder/UpdateFolder`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          ...targetFolder,
          id: targetFolder.id,
          accountId: designerId,
          entityIds,
          isAvailableAtLink: targetFolder.isAvailableAtLink ?? true,
        }),
      })

      return response?.status === 200 || response?.status === 204
    },
    [designerId, fetchFolders]
  )

  return {
    fetchFolders,
    mapFoldersToOptions,
    createFolder,
    updateFolderProjects,
  }
}

export type { PortfolioFolder }
import { API, Endpoints } from "@brg/api"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import urlApi from "shared/actions/urlApi"
import { SelectBoxOption } from "shared/components/inputs/SelectBox"

type PortfolioFolder = {
  id: string
  name: string
  description?: string
  entityIds?: string[]
  isAvailableAtLink?: boolean
  isDefault?: boolean
  isHidden?: boolean
  parentFolderIds?: string[]
  entityType?: string
}

type UseMagistracyPortfolioFoldersProps = {
  designerId?: string
}

export const useMagistracyPortfolioFolders = ({ designerId }: UseMagistracyPortfolioFoldersProps) => {
  const { t } = useTranslation()

  const fetchFolders = useCallback(async (): Promise<PortfolioFolder[]> => {
    if (!designerId) {
      return []
    }

    const data = await urlApi().fetchFolders(designerId)
    if (!Array.isArray(data)) {
      return []
    }

    return data
      .filter((folder) => folder?.id && folder?.name)
      .map((folder) => ({
        id: String(folder.id),
        name: String(folder.name),
        description: folder.description ?? "",
        entityIds: Array.isArray(folder.entityIds) ? folder.entityIds : [],
        isAvailableAtLink: folder.isAvailableAtLink,
        isDefault: folder.isDefault,
        isHidden: folder.isHidden,
        parentFolderIds: folder.parentFolderIds,
        entityType: folder.entityType,
      }))
  }, [designerId])

  const mapFoldersToOptions = useCallback((folders: PortfolioFolder[]): SelectBoxOption[] => {
    return folders.map((folder) => ({
      identifier: folder.id,
      name: folder.name,
    }))
  }, [])

  const generateFolderName = useCallback(async (): Promise<string> => {
    const localizedBaseName = t("magistracyPage.portfolio.default_folder_name")
    const folders = await fetchFolders()

    const existingNames = folders.map((folder) => folder.name)
    let folderName = localizedBaseName
    let counter = 2

    while (existingNames.includes(folderName)) {
      folderName = `${localizedBaseName} - ${counter}`
      counter++
    }

    return folderName
  }, [fetchFolders, t])

  const resolveCreatedFolderId = useCallback(
    (
      foldersBefore: PortfolioFolder[],
      foldersAfter: PortfolioFolder[],
      folderName: string,
      entityIds: string[]
    ): string | null => {
      const folderIdsBefore = new Set(foldersBefore.map((folder) => folder.id))

      const newFolder = foldersAfter.find((folder) => !folderIdsBefore.has(folder.id))
      if (newFolder?.id) {
        return newFolder.id
      }

      const folderByName = foldersAfter.find((folder) => folder.name === folderName)
      if (folderByName?.id) {
        return folderByName.id
      }

      if (entityIds.length === 0) {
        return null
      }

      const folderByProjects = foldersAfter.find((folder) => {
        const ids = folder.entityIds ?? []
        if (ids.length !== entityIds.length) {
          return false
        }
        return entityIds.every((id) => ids.includes(id))
      })

      return folderByProjects?.id ?? null
    },
    []
  )

  const createFolder = useCallback(
    async (entityIds: string[] = []): Promise<string | null> => {
      if (!designerId) {
        return null
      }

      const foldersBefore = await fetchFolders()
      const folderName = await generateFolderName()

      const response = await API.request()
        .endpoint(Endpoints.folders)
        .url("/api/Folder/CreateFolder")
        .body({
          name: folderName,
          description: "",
          isAvailableAtLink: true,
          entityIds,
          accountId: designerId,
        })
        .post()
        .send()

      const status = response?.status
      const isSuccess = status === 200 || status === 201 || status === 204

      if (!isSuccess) {
        return null
      }

      try {
        const data = await response.json()
        if (data?.message === "Too many folders") {
          return null
        }
        if (data?.id) {
          return String(data.id)
        }
      } catch {
        // 204 No Content — empty body
      }

      const foldersAfter = await fetchFolders()
      return resolveCreatedFolderId(foldersBefore, foldersAfter, folderName, entityIds)
    },
    [designerId, fetchFolders, generateFolderName, resolveCreatedFolderId]
  )

  const updateFolderProjects = useCallback(
    async (folderId: string, entityIds: string[]): Promise<boolean> => {
      if (!designerId || !folderId) {
        return false
      }

      const folders = await fetchFolders()
      const targetFolder = folders.find((folder) => folder.id === folderId)
      if (!targetFolder) {
        return false
      }

      const response = await API.fetch(`${Endpoints.folders}/api/Folder/UpdateFolder`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          ...targetFolder,
          id: targetFolder.id,
          accountId: designerId,
          entityIds,
          isAvailableAtLink: targetFolder.isAvailableAtLink ?? true,
        }),
      })

      return response?.status === 200 || response?.status === 204
    },
    [designerId, fetchFolders]
  )

  return {
    fetchFolders,
    mapFoldersToOptions,
    createFolder,
    updateFolderProjects,
  }
}

export type { PortfolioFolder }
